<template>
  <modal title="Edit KPIs" btn="Save" @close="$emit('close')" @submit="save">
    <div class="row" v-for="kpi in kpis" :key="kpi.id">
      <h-input label="Name" v-model="kpi.name" /> 
      <button type="button" class="align-bottom" @click="destroy(kpi)">
        <h-icon>delete</h-icon>
      </button>
    </div>
  </modal>
</template>

<script>
import modal from "@/components/modal/default";
import snackbar from "@/services/hubs/snackbar";
import store from "@/services/api/store";

export default {
  props: ["kpis"],
  components: { modal },
  methods: {
    destroy(kpi) {
      snackbar.update("Deleted");
      this.$emit("destroy", kpi.id);
    },
    save() {
      snackbar.update("Saved");
      this.kpis.map(k => {
        return store.update("ClientKPI", k.id, {name: k.name}, {method: 'patch'})
      });
      this.$emit("close");
    }
  }
};
</script>

<style lang="less" scoped>
.kpi-edit {
  .btns {
    @media (max-width: 600px){
      margin-top: -30px;
    }
  };
}
.align-bottom {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  flex-direction: column;
  i {
    font-size: 30px;
  }
}
</style>

